export const createMiddlewareHandlers = (handlers) => (store) => (next) => (
  action
) =>
  handlers[action.type]
    ? handlers[action.type]({ store, next, action })
    : next(action);
